import axiosRequest from '@/utils/request'
import axios from 'axios'
// 充值
export const topUp = (data) => {
  return axiosRequest({
    url: '/trade/top-up',
    data,
    method: 'post',
    showMessage: false
  })
}

// otp短信
export const getBankOtp = (data) => {
  return axiosRequest({
    url: '/user/get-bank-otp',
    data,
    method: 'post',
    showMessage: false
  })
}

// 结果页面
export const tradeDetail = (data, cancelToken) => {
  return axiosRequest({
    url: '/trade/trade-detail',
    data,
    method: 'post'
  }, {
    cancelToken: new axios.CancelToken((cancel) => {
      cancelToken && cancelToken(cancel)
    })
  })
}
